import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http, fail } from "@/adminApi";

const STATUSES = ["new", "replied", "closed"];

export function SupportTable() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    http.get("/admin/support").then((r) => setItems(r.data)).catch(fail);
  }, []);
  const setStatus = async (id, status) => {
    try {
      const r = await http.put(`/admin/support/${id}`, { status });
      setItems((list) => list.map((x) => (x.message_id === id ? r.data : x)));
      toast.success(`Message ${id} marked ${status}`);
    } catch (e) {
      fail(e);
    }
  };
  return (
    <section className="admin-section" data-testid="admin-support">
      <h2>
        Support messages <i>{items.length}</i>
      </h2>
      {!items.length ? (
        <p className="admin-empty" data-testid="admin-support-empty">No support messages yet.</p>
      ) : (
        <div className="admin-table-wrap">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Message</th>
                <th>Customer</th>
                <th>Details</th>
                <th>Email alert</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {items.map((x) => (
                <tr key={x.message_id} data-testid={`admin-support-row-${x.message_id}`}>
                  <td>
                    <b>{x.message_id}</b>
                    <span>{new Date(x.created_at).toLocaleString()}</span>
                  </td>
                  <td>
                    <b>{x.name}</b>
                    <span>
                      <a href={`mailto:${x.email}`}>{x.email}</a>
                    </span>
                  </td>
                  <td>
                    <span className="enquiry-notes">{x.message}</span>
                  </td>
                  <td>
                    <span className={`pay-pill ${x.email_status === "sent" ? "paid" : x.email_status === "failed" ? "failed" : ""}`}>{x.email_status}</span>
                  </td>
                  <td>
                    <select value={x.status} onChange={(e) => setStatus(x.message_id, e.target.value)} data-testid={`admin-support-status-${x.message_id}`}>
                      {STATUSES.map((s) => (
                        <option key={s}>{s}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
}
